var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomSceneryRoof({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 149,
    height: 115,
    viewBox: "0 0 149 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M0 0h149L0 114.162z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F4F4",
    d: "M.5.5v112.65L147.525.5H.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSceneryRoof);
export default __webpack_public_path__ + "static/media/RoomSceneryRoof.3e78ba89eb2c465cb6e39d4f89deffab.svg";
export { ForwardRef as ReactComponent };